export default function () {
    $('[data-muifrm="basket"]').find('[data-muivalue="total"]').on('DOMSubtreeModified', function () {
        var minimumPurchaseAmount = $('#MinimumPurchaseAmount').val();

        if (minimumPurchaseAmount.length < 1)
            return;

        minimumPurchaseAmount = parseInt(minimumPurchaseAmount);

        var frmRef = $(this).closest('form');
        var total = $(frmRef).find('[data-muivalue="total"]').text();

        if (total.length < 1)
            return;

        total = parseInt(total);

        if (total >= minimumPurchaseAmount)
            $('.basket-text').hide();

        if (total < minimumPurchaseAmount)
            $('.basket-text').show();
    });
}